const FETCH_INSUR_PEOPLE_REQUEST = "FETCH_INSUR_PEOPLE_REQUEST";
const FETCH_INSUR_PEOPLE_SUCCESS = "FETCH_INSUR_PEOPLE_SUCCESS";
const FETCH_INSUR_PEOPLE_FAILURE = "FETCH_INSUR_PEOPLE_FAILURE";

export default {
  FETCH_INSUR_PEOPLE_REQUEST,
  FETCH_INSUR_PEOPLE_SUCCESS,
  FETCH_INSUR_PEOPLE_FAILURE,
};
